import { useIntl } from '@/intl'
import { Button } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

interface GoBackProps {
  onClick?: () => void
}

const Btn = styled(Button)`
  width: fit-content;
`

export function GoBack({ onClick = () => {} }: GoBackProps) {
  const intl = useIntl()
  const handleGoBack = () => {
    onClick()
  }
  return (
    <Btn data-qa="go-back-btn" variant="transparentNeutral" onClick={() => handleGoBack()}>
      <Button.Icon glyph="ChevronLeft" />
      {intl.formatMessage({ id: 'prices_go-back' })}
    </Btn>
  )
}
